const AUTH = 'auth';
const AUTH_TOKEN = `${AUTH}/token`;
const AUTH_REFRESH_TOKEN = `${AUTH}/refreshtoken`;
const COMPANIES = 'companies';
const AGENCIES = 'agencies';
const ADMIN_REQUESTS = 'admin_access_requests';
const CONVERSATIONS = 'conversations';
const CONVERSATION_CREATE_MESSAGE = id => `${CONVERSATIONS}/${id}/messages`;

const COUNTRIES_ENDPOINT = 'countries';
const COUNTRY_CITY_ENDPOINT = countryId => `${COUNTRIES_ENDPOINT}/${countryId}/cities`;
const CITY_ENDPOINT = `${COUNTRIES_ENDPOINT}/cities`;
const FILTER_AGGREGATION_SEARCH = endpoint => `${endpoint}/aggregations`;
const FORGOT_PASSWORD = `${AUTH}/forgotPassword`;
const LANGUAGES_LIST = 'languages';
const PERFORMANCES = 'performances';
const PRODUCTIONS = 'productions';
const CASTS_ENDPOINT = `${PRODUCTIONS}/castings`;
const PRODUCTIONS_AGGREGATIONS = 'productions/aggregations';
const PRODUCTIONS_NEWANDRARE = 'productions/newandrare';
const NEWANDRARE_AGGREGATIONS = 'productions/newandrare/aggregations';
const COMPETITIONS = 'competitions';
const COMPETITIONS_AGGREGATIONS = 'competitions/aggregations';
const REPERTOIRE = 'repertoire';
const PROFILES_ENDPOINT = 'profiles';
const PROFILES_BIO_ENDPOINT = profileId => `${PROFILES_ENDPOINT}/${profileId}/descriptions`;
const PROFILE_CONTACTS_ENDPOINT = profileId => `${PROFILES_ENDPOINT}/${profileId}/contacts`;
const SEARCH_ENDPOINT = 'search';
const JOBS_ENDPOINT = 'jobs';
const MUSICAL_WORK_ENDPOINT = 'works';
const MUSICAL_WORK_TYPES_ENDPOINT = `${MUSICAL_WORK_ENDPOINT}/types`;
const MUSICAL_WORK_STYLES_ENDPOINT = `${MUSICAL_WORK_ENDPOINT}/styles`;
const MUSICAL_WORK_LIBRETTIST_ENDPOINT = `${MUSICAL_WORK_ENDPOINT}/librettists`;
const VENUES = 'venues';
const VENUES_STAGES_ENDPOINT = venueId => `${VENUES}/${venueId}/stages`;
const VENUES_CONTACTS = id => `${VENUES}/${id}/${CONTACTS}`;
const CONTACTS = 'contacts';
const VENUES_AGGREGATIONS = 'venues/aggregations';
const NETWORK_INVITATIONS = 'network/invitations';
const PROJECT_CANDIDATES = id => `${PROJECTS}/${id}/candidates`;
const PROJECTS = 'projects';
const FESTIVALS = 'festivals';
const FESTIVAL_CONTACTS = id => `${FESTIVALS}/${id}/${CONTACTS}`;
const FESTIVAL_EMPLOYEES = festivalId => `${FESTIVALS}/${festivalId}/${EMPLOYEES}`;
const FESTIVAL_CERTAIN_EMPLOYEE = employeeId =>
  employeeId ? `${FESTIVALS}/${EMPLOYEES}/${employeeId}` : `${FESTIVALS}/${EMPLOYEES}`;
const FESTIVAL_DESCRIPTIONS = id => `${FESTIVALS}/${id}/translations`;
const ARTISTS = 'artists';
const ARTICLES = 'articles';
const COMPOSER = 'works/composers';
const COMPOSER_REVIEWS = id => `${COMPOSER}/${id}/reviews`;
const WORK_ROLES = 'works/roles';
const AGENTS = 'agents';
const RENTALS = 'rentals';
const OFFICES = 'offices';
const NETWORK = 'network';
const CONNECTIONS = 'connections';
const INVITATIONS = 'invitations';
const ONTHISDAY = date => `stats/onthisday${date ? `/${date}` : ''}`;
const ACCOUNT_CREATE = 'users';
const ACCOUNT_SETTINGS = userId => `users/${userId}/settings`;
const SUBSCRIPTIONS = 'subscriptions';
const PRODUCTS = 'products';
const CHECKOUTS = 'checkouts';
const REGISTRATIONS = 'users/registrations';
const ADVANCED_STATS = 'stats/advanced';
const ADVANCED_STATS_AGGREGATIONS = 'stats/advanced/aggregations';
const USER_SUBSCRIPTIONS = userId => `users/${userId}/subscriptions`;
const PRODUCTION_CASTS = productionId => `productions/${productionId}/casts`;
const AGENT_PROFILE_AGENCIES = `${AGENCIES}/${AGENTS}`;
const ARTIST_PROFILE_AGENCIES = `${AGENCIES}/${ARTISTS}`;

const AGENCY = id => `${AGENCIES}/${id}`;
const AGENCY_ARTISTS = id => `${AGENCIES}/${id}/${ARTISTS}`;
const AGENCY_AGENTS = id => `${AGENCIES}/${id}/${AGENTS}`;
const AGENCY_CONTACTS = id => `${AGENCIES}/${id}/${CONTACTS}`;
const AGENCY_REQUESTS = id => `${AGENCIES}/${id}/access_requests`;

const AGENCY_CERTAIN_AGENT = (agencyId, agentId) => `${AGENCIES}/${agencyId}/${AGENTS}/${agentId}`;

const OFFICE = (agencyId, officeId) => `${AGENCIES}/${agencyId}/${OFFICES}${officeId ? `/${officeId}` : ''}`;

const EMPLOYEES = 'employees';
const COMPANY_DESCRIPTIONS = companyId => `${COMPANIES}/${companyId}/translations`;
const COMPANY_EMPLOYEES = companyId => `${COMPANIES}/${companyId}/${EMPLOYEES}`;
const COMPANY_CONTACTS = companyId => `${COMPANIES}/${companyId}/${CONTACTS}`;
const COMPANY_CERTAIN_EMPLOYEE = employeeId =>
  employeeId ? `${COMPANIES}/${EMPLOYEES}/${employeeId}` : `${COMPANIES}/${EMPLOYEES}`;

const PROFILE_CONNECTIONS = profileId => `${NETWORK}/connections?participant_id=${profileId}`;
const PROFILE_ACCESSES = `${PROFILES_ENDPOINT}/profileaccesses`;
const PROFILE_ACCESS_REQUESTS = `${PROFILES_ENDPOINT}/profileaccessrequests`;

const ARTIST_AGREEMENTS = `${AGENCIES}/agreements`;

const AGENCY_AGENTS_INVITATIONS = agencyId => `${AGENCIES}/${agencyId}/${INVITATIONS}`;
const AGENCY_OFFICES = agencyId => `${AGENCIES}/${agencyId}/${OFFICES}`;

const PROFILE_REPERTOIRE = profileId => `${PROFILES_ENDPOINT}/${profileId}/${REPERTOIRE}`;
const MEDIA = 'media';
const MEDIA_ATTRIBUTES = 'media/attributes';
const REVIEWS = profileId => `${PROFILES_ENDPOINT}/${profileId}/reviews`;

const STATS_NUMBERS = `stats/numbers`;
const STATS_NUMBERS_BY_ID = id => `stats/numbers/${id}`;
const SEASONS = 'seasons';
const SEASONS_COMPANIES = 'seasons/companies';
const PROFESSIONS = 'professions';
const PROFESSION_QUALIFICATIONS_ENDPOINT = `${PROFESSIONS}/qualifications`;
const AOS_PROFESSIONS = `${COMPANIES}/employees/professions`;
const FESTIVAL_PROFESSIONS = `${FESTIVALS}/employees/professions`;
const REGIONS = 'regions';
const PING_URL = 'users/ping/status';
const BANK_CARDS = 'users/cards';
const REQUESTACCESS = `${PROFILES_ENDPOINT}/accessrequests`;
const PRIVACY_OPTIONS = 'privacy_attributes';
const PRODUCTION_DOCUMENTS = `${PRODUCTIONS}/documents`;
const PRODUCTION_PRIVACY = productionId => `${PRODUCTIONS}/${productionId}/privacy`;

const PRODUCTION_DATES = productionId => `${PRODUCTIONS}/${productionId}/dates`;
const PRODUCTION_DOCUMENTS_BY_ID = productionId => `${PRODUCTIONS}/${productionId}/documents`;
const PRODUCTION_ACTIONS = productionId => `${PRODUCTIONS}/${productionId}/actions`;

const SUPPORT_REQUESTS = 'users/supportRequests';

module.exports = {
  AUTH,
  AUTH_TOKEN,
  AUTH_REFRESH_TOKEN,
  BANK_CARDS,
  COMPANIES,
  AGENCIES,
  ADMIN_REQUESTS,
  CONVERSATIONS,
  CONVERSATION_CREATE_MESSAGE,
  COUNTRIES_ENDPOINT,
  FILTER_AGGREGATION_SEARCH,
  FORGOT_PASSWORD,
  LANGUAGES_LIST,
  PERFORMANCES,
  PRODUCTIONS,
  PRODUCTIONS_NEWANDRARE,
  NEWANDRARE_AGGREGATIONS,
  COMPETITIONS,
  COMPETITIONS_AGGREGATIONS,
  REPERTOIRE,
  PROFILES_ENDPOINT,
  PROFILE_ACCESSES,
  PROFILE_ACCESS_REQUESTS,
  SEARCH_ENDPOINT,
  JOBS_ENDPOINT,
  MUSICAL_WORK_ENDPOINT,
  MUSICAL_WORK_TYPES_ENDPOINT,
  MUSICAL_WORK_STYLES_ENDPOINT,
  MUSICAL_WORK_LIBRETTIST_ENDPOINT,
  VENUES,
  VENUES_CONTACTS,
  VENUES_AGGREGATIONS,
  NETWORK_INVITATIONS,
  PROJECT_CANDIDATES,
  PROJECTS,
  FESTIVALS,
  FESTIVAL_CONTACTS,
  ARTISTS,
  ARTICLES,
  COMPOSER,
  WORK_ROLES,
  AGENTS,
  RENTALS,
  OFFICES,
  NETWORK,
  CONNECTIONS,
  INVITATIONS,
  ONTHISDAY,
  ACCOUNT_CREATE,
  ACCOUNT_SETTINGS,
  SUBSCRIPTIONS,
  PRODUCTS,
  CHECKOUTS,
  ADVANCED_STATS,
  USER_SUBSCRIPTIONS,
  AGENT_PROFILE_AGENCIES,
  ARTIST_PROFILE_AGENCIES,
  AGENCY,
  AGENCY_ARTISTS,
  AGENCY_AGENTS,
  AGENCY_CONTACTS,
  AGENCY_REQUESTS,
  AGENCY_CERTAIN_AGENT,
  OFFICE,
  EMPLOYEES,
  COMPANY_EMPLOYEES,
  COMPANY_CONTACTS,
  COMPANY_CERTAIN_EMPLOYEE,
  PROFILE_CONNECTIONS,
  ARTIST_AGREEMENTS,
  AGENCY_AGENTS_INVITATIONS,
  AGENCY_OFFICES,
  PROFILE_REPERTOIRE,
  MEDIA,
  REVIEWS,
  STATS_NUMBERS,
  STATS_NUMBERS_BY_ID,
  SEASONS,
  SEASONS_COMPANIES,
  PROFESSIONS,
  PROFESSION_QUALIFICATIONS_ENDPOINT,
  REGIONS,
  REQUESTACCESS,
  PING_URL,
  REGISTRATIONS,
  PRODUCTION_DATES,
  PROFILES_BIO_ENDPOINT,
  PRIVACY_OPTIONS,
  PROFILE_CONTACTS_ENDPOINT,
  PRODUCTIONS_AGGREGATIONS,
  ADVANCED_STATS_AGGREGATIONS,
  PRODUCTION_CASTS,
  MEDIA_ATTRIBUTES,
  COUNTRY_CITY_ENDPOINT,
  CITY_ENDPOINT,
  VENUES_STAGES_ENDPOINT,
  AOS_PROFESSIONS,
  COMPOSER_REVIEWS,
  PRODUCTION_DOCUMENTS,
  PRODUCTION_PRIVACY,
  COMPANY_DESCRIPTIONS,
  PRODUCTION_DOCUMENTS_BY_ID,
  CASTS_ENDPOINT,
  PRODUCTION_ACTIONS,
  FESTIVAL_EMPLOYEES,
  FESTIVAL_CERTAIN_EMPLOYEE,
  FESTIVAL_DESCRIPTIONS,
  FESTIVAL_PROFESSIONS,
  SUPPORT_REQUESTS,
};
